import React, { createContext, ReactNode, useContext } from "react";

const TabIndexContext = createContext<{}>({});

export default TabIndexContext;

export function ProvideTabIndex({ children, value }: { children: ReactNode; value: {} }) {
    return <TabIndexContext.Provider value={value}>{children}</TabIndexContext.Provider>;
}

export const useTabIndex = () => useContext(TabIndexContext);
